module.exports = __webpack_public_path__ + "img/house.81e7bbd.svg";